
import { Prop, Vue, Component } from 'vue-property-decorator'
import { CharmTag } from '@/interfaces/CharmTag'

import strings from '@/assets/strings.json'

@Component
export default class CharmsFilters extends Vue {
  @Prop({ default: [] }) charmTags!: CharmTag[];
  @Prop() filterCharms!: Function;

  private selectedTagId: number | null = null

  private charmsFiltersStrings = strings.Step3.CharmsFilters

  private onFilterClick (tag?: CharmTag) {
    this.selectedTagId = tag ? tag.id : null
    this.filterCharms(tag)
  }
}
